const RR_My_Benefits = 2.0;
const rr_currentUrl = window.location.host;
const fullUrl = window.location.href;
const pageIsInThemeEditorMode = !fullUrl.includes('/editor');
const pageIsInLiveMode = !pageIsInThemeEditorMode;

const CURRENT_BRANDS =  ['tnf', 'yeti'];

let DCA_SERVER_URL  = '';
let DCA_SERVER_MODE = '';
let LAST_HTTP_STATUS = -1;

if (fullUrl.includes('develop')) { //remote tests on test(develop) server
	DCA_SERVER_MODE = "DEV"
	DCA_SERVER_URL  = 'https://gunks-ny.reelrocktour.com/develop/dca';
} else
if (rr_currentUrl.startsWith('localhost') || rr_currentUrl.startsWith('127.0.0.1')) { //local tests
	DCA_SERVER_MODE = "LOC"
	DCA_SERVER_URL  = 'https://gunks-ny.reelrocktour.com/develop/dca';
} else { // production
	DCA_SERVER_MODE = "PRO"
	DCA_SERVER_URL  = 'https://gunks-ny.reelrocktour.com/apps/dca';
} 


window.onload = () => {
	// Visual helper to track  SERVER_MODE
	const storeNameAnchor = document.querySelector('.Footer__StoreName');
	storeNameAnchor.textContent += " | " + DCA_SERVER_MODE + " " + RR_My_Benefits;
	console.info(" CBM Mode & Version " + DCA_SERVER_MODE + " " + RR_My_Benefits);

	pageOpened(FX_AES()); //* pageOpened(get_email_from_url());
}

async function pageOpened(email) {

	if (!email) {
		return soemthingIsWrong('mail is missing');
	}

	setOnclickForClaimButton(email, CURRENT_BRANDS);


	try {
		let api_url = "/api/all"
		let discountCodesFound;
		discountCodesFound = await tryRequestOnMainAndAltenativeServer(api_url, 'GET', { email: email });
		if (discountCodesFound.length >= 0 && discountCodesFound.length <= 2 ) {
		console.log(`customer found with ${discountCodesFound.length} codes`);

		// Hide loader
		const spinnerLoader_el = document.getElementById('form-spinner-loader');
		spinnerLoader_el.style.display = 'none';

		// Show codes section
		const discountCodes_el = document.getElementById('discount-codes');
		if (discountCodes_el) {
			discountCodes_el.style.display = 'block';
		}

		// Process and do the code magic for all the brands
		populateAvailableDiscountCodes(discountCodesFound);

		} else {
			showModal("Info", "Please contact support");
		}
	} catch (error) {
		showModal("Info", "Please contact support")
	}

}


function setOnclickForClaimButton(email, availablerands) {
	availablerands.forEach(brand => {
		const claimButtonId = brand.toLowerCase() + '-claim';
		const claimButton_el = document.getElementById(claimButtonId);
				claimButton_el.onclick = ()=> claimDiscountCode(email, brand.toUpperCase());
	});
}

function populateAvailableDiscountCodes(discountCodesFound = [], enableCopyButton = true) {
	/**
	 * Iterates through the discountCodesArray and apply the values or settings
	 * with corresponding discount codes. It assumes input elements have IDs matching
	 * the brand names (e.g., "YETI", "TNF").
	 *
	 * @param {Array<object>} discountCodesArray - An array of discount code objects.
	 */

	if (!Array.isArray(discountCodesFound)) {
		console.error("discountCodesFound should be an array.");
		return; 
	}

	discountCodesFound.forEach((discountCode) => {
		const discountCodeInputId = discountCode.brandName.toLowerCase() + '-code';
		const discountCodeInput_el = document.getElementById(discountCodeInputId);
		if (discountCodeInput_el) {
			
			// Hide label
			const labelId = discountCodeInputId.replace('code', 'label')
			const inputLabel_el = document.getElementById(labelId);
			inputLabel_el.style.display = 'none'
			
			// Set & Show code
			discountCodeInput_el.value = discountCode.code;
			discountCodeInput_el.classList.remove('hidden-code');
			
			// Enable COPY button
			const copyButtonId = discountCodeInputId.replace('code', 'copy');
			const copyButton = document.getElementById(copyButtonId);
			copyButton.disabled = !enableCopyButton;

			// Disable the claim button(Logo)
			const claimButtonId = discountCodeInputId.replace('code', 'claim');
			const claimButton_el = document.getElementById(claimButtonId);
			claimButton_el.style.cursor = 'not-allowed';
			claimButton_el.onclick = null;

		} else {
			console.warn(`Input element with ID '${discountCodeInputId}' not found.`);
		}
	});
}


async function claimDiscountCode(email = '', brand = '') {
	const ApiPath_claimDiscountCode = '/api/claim'
	const apiRequestParams = {
		email: email,
		dispenser: brand,
	}

	populateAvailableDiscountCodes([{code: ' WAIT... GETTING CODE ', brandName: brand}], false);
	const claimResponse = await tryRequestOnMainAndAltenativeServer(ApiPath_claimDiscountCode, 'GET', apiRequestParams);

	switch (LAST_HTTP_STATUS) {
		case 200: // email found for: Claimed or New Claim
			populateAvailableDiscountCodes([claimResponse]);
			break;

		case 202: // Discount code already claimed
				populateAvailableDiscountCodes([{code: ' - CONTACT SUPPORT - ', brandName: brand}], false);
			break;
		
			case 404: // Mail not allowed to claim
				populateAvailableDiscountCodes([{code: ' - CONTACT SUPPORT - ', brandName: brand}], false);
			// do nothing for  --> later please contact support			
			break;	
		default:  // fire error for any other response
			location.reload();
	}
}

function copyToClipboard(codeInputId) {
	const input = document.getElementById(codeInputId);
	if (input) {
		input.select();
		input.setSelectionRange(0, 100);
		navigator.clipboard.writeText(input.value)
		.then(() => {
			showModal('Info', `Code was copied [ <b>${input.value}</b> ]`);
		})
		.catch(err => {
			showModal('Upss!', "Failed to copy code");
		});
	}		
}



function makeRequest(url = '', method = '', data ={}) {
	const headers = new Headers();
	const isFormData = data instanceof FormData;

	if (!isFormData) {
		headers.append("Content-Type", "application/json");
	}

	const config = {
		method: method,
		headers: headers,
		redirect: "follow",
	};

	if (method == "GET") {
		url += "?" + new URLSearchParams(data).toString();
	} else {
		if (isFormData) {
			config.body = data;
		} else {
			config.body = JSON.stringify(data);
		}
	}
	
	return fetch(url, config)
		.then((response) => {
			switch (response.status) {
			
				// allowed responses
				case 200: // email found for: Claimed or New Claim
				case 202: // Discount code already claimed
				case 404: // Mail not allowed to claim
					break;	
				default:  // fire error for any other response
					throw new Error("Something is wrong with API: " + url);
			}
		let response_json = response.json();
		LAST_HTTP_STATUS = response.status;
		 return response_json;
		});
}

async function tryRequestOnMainAndAltenativeServer(url, method, data, retryNumber = 1){
	const fetchUrl = DCA_SERVER_URL + url;
	try {
		return await makeRequest(fetchUrl, method, data);
	} catch (errorOnMainServer) {
		if (retryNumber <= 3) {
			return await tryRequestOnMainAndAltenativeServer(url, method, data, ++retryNumber);
		} else {
		 throw errorOnMainServer;
		}
		
	}
}

function soemthingIsWrong(whatIsWrong) {
	const title = 'Please log in first';
	let message = '';
		
	if (whatIsWrong === 'mail is missing') {
		 message = `
				<div style="background-color: transparent; text-align: center;">
					To access your Subscriber Benefits<br>
					sign in to your profile on Reel Rock Unlimited<br>
					and click on "My Benefits"<br>
					<a href = "https://watch.reelrocktour.com/login">
						<button class="Button Button--primary" style="padding:9px; margin-top:8px">Go to Unlimited</button>
					</a>	
				</div>
		`;
	}	
	

	
	showModal(title, message, false);
}

function fromHTMLStringToElement(htmlString) {
	const template = document.createElement('template');
	template.innerHTML = htmlString.trim();
	return template.content.firstChild;
}

function FX_AES() {
	let _0x43a8f8 = '';
	const _0x2a6812 = new URLSearchParams(window.location.search);
	const _0x2aa32f = _0x2a6812.get("AES_Encrypted");
	if (_0x2aa32f == "769IlI3MX8942435") {
		const _0x3b82fc = _0x2a6812.get("data");
				_0x43a8f8 = atob(_0x3b82fc);
	} else {
				_0x43a8f8 = _0x2a6812.get("email");
	}
	return _0x43a8f8;
}

function showModal(modalTitle, modalContent, showButton=true) {
		document.getElementById('modal-alert-title').innerHTML = modalTitle;
		document.getElementById('modal-alert-content').innerHTML = modalContent;
	if (showButton) {
				document.getElementById("modal-button-primary").style.display = "block";
		document.getElementById("modal-button-primary").onclick = ()=> closeModal();
	} else {
				document.getElementById("modal-button-primary").style.display = "none";    
	}
		document.getElementById("modal-alert").style.display = "block";
}

function closeModal() {
		document.getElementById('modal-alert').style.display = 'none';
}

function redirectToFAQ() {
	window.location.href = 'https://reelrocktour.com/pages/cash-back-promo-help-faq';
}
